import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { AuthorService } from "src/app/inventory/author/author.service";
import { PublisherService } from "src/app/inventory/publisher/publisher.service";
import { Page } from "src/app/util/page";
import { StringCriteriaSearchComponent } from "src/app/util/search/criteria/string-criteria-search.component";

@Component({
  selector: 'publisher-search-criteria',
  styleUrls: ['../../../../util/search/criteria/criteria-search.component.css'],
  templateUrl: '../../../../util/search/criteria/criteria-search.component.html'
})
export class PublisherSearchCriteriaComponent extends StringCriteriaSearchComponent {
  @Input()
  public loading!: boolean;
  
  constructor(publisherService: PublisherService) {
    super("Éditeur", query => publisherService.findByNameLike(query));
  }

  formatResultsMetadataLabel(): string {
    return "éditeur(s) affiché(s) sur";
  }
}